"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _withPropsOnChange = _interopRequireDefault(require("recompose/withPropsOnChange"));

var _lifecycle = _interopRequireDefault(require("recompose/lifecycle"));

var _branch = _interopRequireDefault(require("recompose/branch"));

var _componentFromProp = _interopRequireDefault(require("recompose/componentFromProp"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

var _getCenters = _interopRequireDefault(require("./helpers/getCenters"));

var _createStyles = _interopRequireDefault(require("./helpers/createStyles"));

var _defaultConstants = require("./defaultConstants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

/**
 * This component renders and animates the text as an Alphabet Soup
 * @param {string} text text to render
 * @param {number} [width=100] width of the space in pixels
 * @param {number} [height=100] height of the space in pixels
 * @param {string} [fontSize='20px'] fontSize of the text when tidy.
 * @param {number} [lineHeight=1.3] lineHeight of the text when tidy.
 * @param {string} [fontFamily='Georgia'] fontFamily of the text.
 * @param {string} [transitionStyle='constant'] style of the transition animation. Values: 'constant' | 'progressive' | 'random'.
 * @param {string} [transitionSpeedMultiplier=1] speed multiplier for the transition. Default transitions take 1s. The multiplier can increase and decrease that.
 * @param {string} [transitionTimingFunction='ease'] is the transition timing function used on CSS transition. e.g. ease, ease-in, cubic-bezier(1, 0.24, 0.25, 1), ...
 * @param {number} [maxIterations=20] maximum number of iterations that the Lloyd's relaxation will run through.
 * More iterations mean a more optimal solution, however it can take a lot more time. Less iteration generate less optimal solutions.
 * @param {number} [acceptableError=1e-6] error that if achieved between iterations the relaxation process will stop, even if the iterations are not completed.
 * Bigger error with compute results faster.
 * @param {string} [sorting='none'] sorting applied to the generated points. 'none' no sorting applied. 'sortByX' sort ascending points using X.
 * 'sortByY' sort ascending points using Y. 'costFunction' sorts points using a cost function like `x + costFunctionYWeight * y`.
 * @param {number} [costFunctionYWeight=1] weight applied to Y in the sorting cost function if sorting='costFunction'.
 * @param {string} [wrapperClassName=''] class name of the wrapper component.
 * @param {string} [charactersClassName=''] class name of the characters. It will be applied to all the characters.
 * @param {boolean} [untidyOnHover=false] reverses the behaviour. The text is tidy by default and gets untidy when hover
 * @param {boolean} [vertical=false] when true, the tidied text renders in vertical.

 * @returns renders the React component
 */
const AlphabetSoup = props => {
  const _props$classes = props.classes,
        classes = _props$classes === void 0 ? {} : _props$classes,
        text = props.text,
        wrapperClassName = props.wrapperClassName,
        charactersClassName = props.charactersClassName;
  return React.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      position: 'relative'
    },
    className: (0, _classnames.default)(wrapperClassName ? [wrapperClassName] : null, classes.wrapper)
  }, text.split('').map((char, index) => {
    return React.createElement("div", {
      className: (0, _classnames.default)(charactersClassName ? [charactersClassName] : null, classes[`char-${index}`]),
      key: `${char}-${index}`
    }, char);
  }));
};

AlphabetSoup.defaultProps = {
  fontFamily: _defaultConstants.DEFAULT_FONT_FAMILY,
  fontSize: _defaultConstants.DEFAULT_FONT_SIZE,
  lineHeight: _defaultConstants.DEFAULT_LINE_HEIGHT,
  wrapperClassName: undefined,
  charactersClassName: undefined
};
const enhancer = (0, _compose.default)((0, _branch.default)(() => {
  return typeof document === 'undefined';
}, () => () => React.createElement("div", null)), (0, _withPropsOnChange.default)(['width', 'height'], ({
  width,
  height
}) => {
  // If width or height are 0 or negative the function will fallback to calculate the points for a 100x100 space
  if (width <= 0 || height <= 0) {
    width = _defaultConstants.DEFAULT_WIDTH;
    height = _defaultConstants.DEFAULT_HEIGHT;
  }

  return {
    width,
    height
  };
}), (0, _lifecycle.default)({
  componentDidMount() {
    const _this$props = this.props,
          text = _this$props.text,
          width = _this$props.width,
          height = _this$props.height,
          maxIterations = _this$props.maxIterations,
          acceptableError = _this$props.acceptableError,
          sorting = _this$props.sorting,
          costFunctionYWeight = _this$props.costFunctionYWeight;
    (0, _getCenters.default)(text.length, {
      width,
      height,
      maxIterations,
      acceptableError,
      sorting,
      costFunctionYWeight
    }).then(result => {
      this.setState({
        charCenters: result
      });
    });
  }

}), (0, _withPropsOnChange.default)(['text', 'charCenters'], ({
  text,
  width,
  height,
  fontSize,
  lineHeight,
  fontFamily,
  transitionStyle,
  transitionSpeedMultiplier,
  transitionTimingFunction,
  charCenters,
  untidyOnHover,
  vertical
}) => {
  return {
    component: (0, _withStyles.default)((0, _createStyles.default)(text, {
      width,
      height,
      fontSize,
      lineHeight,
      fontFamily,
      transitionStyle,
      transitionSpeedMultiplier,
      transitionTimingFunction,
      charCenters,
      untidyOnHover,
      vertical
    }))(AlphabetSoup)
  };
}));

var _default = enhancer((0, _componentFromProp.default)('component'));

exports.default = _default;